import { useRef } from 'react';
import { Box, Button, Card, CardContent, Typography } from '@mui/material';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { SETTINGS_WINTER } from '../../../consts/slick-const';

export const Humidity = ({ data }) => {
    const customeSlider = useRef();
    const handlerPrev = () => {
        customeSlider.current.slickPrev();
    };
    const handlerNext = () => {
        customeSlider.current.slickNext();
    };

    return (
        <div>
            <div className='weather-future_title-slick'>
                <h3 className='weather-future_title'>Вологість, %</h3>
                <div className='weather-future_slick-arrows'>
                    <Button
                        variant='contained'
                        sx={{
                            backgroundColor: '#6565f5',
                            '&:hover': { backgroundColor: '#4d4de9' }
                        }}
                        onClick={handlerPrev}>
                        <NavigateBeforeIcon />
                    </Button>
                    <Button
                        variant='contained'
                        sx={{
                            marginLeft: '6px',
                            backgroundColor: '#6565f5',
                            '&:hover': { backgroundColor: '#4d4de9' }
                        }}
                        onClick={handlerNext}>
                        <NavigateNextIcon />
                    </Button>
                </div>
            </div>
            <Slider {...SETTINGS_WINTER} ref={customeSlider}>
                {data.map((item, index) => (
                    <Card key={index} sx={{ borderRadius: '4px 4px 0 0' }} >
                        <CardContent
                            sx={{ padding: 0, '&:last-child': { paddingBottom: 0 } }}>
                            <Box sx={{ marginBottom: '6px', padding: '16px' }}>
                                <Typography variant='body2' sx={{ marginBottom: '4px', fontSize: '16px' }}>
                                    {item[0][0]}
                                </Typography>
                                <Typography variant='body2' sx={{ fontSize: '16px' }}>
                                    {item[0][1]}
                                </Typography>
                            </Box>
                            <Typography
                                variant='body2'
                                sx={{
                                    paddingTop: '4px',
                                    fontWeight: 'bold',
                                    fontSize: '16px',
                                    backgroundColor: `rgba(106, 90, 205, ${item[1] / 100})`
                                }}>
                                {item[1]}
                            </Typography>
                        </CardContent>
                    </Card>
                ))}
            </Slider>
        </div>
    )
}